<template>
  <el-dialog
    :title="title"
    :visible.sync="showModal"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    width="1080px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="活动标题" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="活动封面" prop="cover_img">
        <upload-one
          v-model="form.cover_img"
          width="300px"
          height="450px"
        ></upload-one>
        <p style="margin: -10px 0 0 0;">(380*214倍数)</p>
      </el-form-item>
      <el-form-item label="主题图片" prop="theme_img">
        <upload-one
          v-model="form.theme_img"
          width="300px"
          height="450px"
        ></upload-one>
        <p style="margin: -10px 0 0 0;">(750*700倍数)</p>
      </el-form-item>

      <el-form-item label="活动人数" prop="activity_total_num">
        <el-input
          style="max-width:220px;"
          v-model.number="form.activity_total_num"
          placeholder="输入活动最大人数"
        ></el-input>
      </el-form-item>

      <el-form-item label="招募时间" prop="recruit_at">
        <el-date-picker
          v-model="form.recruit_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="进行时间" prop="start_at">
        <el-date-picker
          v-model="form.start_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="end_at">
        <el-date-picker
          v-model="form.end_at"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="赠送积分" prop="integarl_num">
        <el-input
          style="max-width:220px;"
          v-model.number="form.integarl_num"
          placeholder="输入积分数"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动详情" prop="content">
        <tinymce
          :height="400"
          v-model="form.content"
          :value="form.content"
          ref="tinymce"
        />
      </el-form-item>
      <el-form-item
        v-for="(item, index) in form.condition"
        :key="index"
        :label="index === 0 ? '填写报名信息' : ''"
        :rules="[
          { required: true, message: '请输入选项内容', trigger: 'blur' },
        ]"
        :prop="'condition[' + index + ']'"
      >
        <div class="ipt-box">
          <el-input
            style="max-width:241px;"
            v-model="form.condition[index]"
            placeholder="请输入内容"
          ></el-input>
          <el-row style="margin-left: 10px;" type="flex">
            <el-button
              icon="el-icon-minus"
              type="danger"
              size="small"
              circle
              @click="removeField(index)"
              v-if="form.condition.length > 1"
            ></el-button>
            <el-button
              icon="el-icon-plus"
              type="primary"
              size="small"
              circle
              @click="addField"
              v-if="form.condition.length === index + 1"
            ></el-button>
          </el-row>
        </div>
      </el-form-item>
      <el-form-item label="问卷模板" prop="questionnaire_id">
        <el-select
          v-model="form.questionnaire_id"
          filterable
          placeholder="请选择"
          :disabled="is_order_questionnaire === 0 ? false : true"
          :loading="questionnaireLoading"
        >
          <el-option
            v-for="item in questionnaireList"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="权重" prop="sort">
        <el-input-number v-model.number="form.sort" :min="1" :max="9999" />
      </el-form-item>
      <el-row type="flex" justify="end">
        <el-button @click="trunOff">取消</el-button>
        <el-button type="primary" @click="submitForm('form')">确认</el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import { addEvent } from '@/api/activity'
import { review } from '@/api/review'
export default {
  data: () => ({
    rules: {
      title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
      cover_img: [{ required: true, message: '请上传封面', trigger: 'blur' }],
      theme_img: [
        { required: true, message: '请上传主题图片', trigger: 'blur' },
      ],
      activity_total_num: [
        {
          type: 'number',
          required: true,
          message: '请输入总人数',
          trigger: 'blur',
        },
        {
          validator: (rules, value, cb) => {
            if (value <= 0) return cb(new Error('总人数必须大于0'))
            cb()
          },
        },
      ],
      recruit_at: [
        { required: true, message: '请选择招聘时间', trigger: 'blur' },
      ],
      start_at: [
        { required: true, message: '请选择进行时间', trigger: 'blur' },
      ],
      end_at: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
      integarl_num: [
        {
          type: 'number',
          required: true,
          message: '请输入积分数',
          trigger: 'blur',
        },
      ],
      content: [
        { required: true, message: '活动详情不能为空', trigger: 'blur' },
      ],
      sort: [{ required: true, message: '请输入权重', trigger: 'blur' }],
      // condition: [
      //     { required: true, message: "请选择结束时间", trigger: 'blur' }
      // ]
    },
    is_order_questionnaire: 0,
    questionnaireLoading: false,
    questionnaireList: [],
    form: {
      id: null,
      title: '',
      cover_img: null,
      theme_img: null,
      recruit_at: null,
      start_at: null,
      end_at: null,
      integarl_num: '',
      content: '',
      condition: [''],
      sort: 1,
      activity_total_num: '',
      questionnaire_id: null,
    },
  }),
  components: {
    Tinymce,
  },
  created() {
    this.initOption()
  },
  props: {
    // 展示
    show: {
      default: false,
      type: Boolean,
    },
    // 模式
    type: {
      default: 'add',
      type: String,
    },
    // 编辑的数据
    editData: null | Object,
  },
  methods: {
    async initOption() {
      this.questionnaireLoading = true

      const questionnaireRes = await review.questionnaireList({
        id: this.form.questionnaire_id,
      })

      this.questionnaireList = questionnaireRes.data

      this.questionnaireLoading = false
    },
    trunOff() {
      this.showModal = false
    },
    handleUpdateFormModelByModalType() {
      const handlers = {
        add: () => {
          this.form = {
            id: null,
            title: '',
            cover_img: null,
            theme_img: null,
            recruit_at: null,
            start_at: null,
            end_at: null,
            content: '',
            condition: [''],
            sort: 1,
          }
          this.is_order_questionnaire = 0
        },
        edit: () => {
          const {
            id,
            title,
            cover_img,
            theme_img,
            recruit_at,
            start_at,
            end_at,
            integarl_num,
            activity_total_num,
            content,
            condition,
            sort,
            questionnaire_id,
          } = this.editData
          let formated = condition.map((item, index) => {
            return item.name
          })
          this.is_order_questionnaire = questionnaire_id
          this.form = {
            questionnaire_id,
            activity_total_num,
            id,
            title,
            cover_img,
            theme_img,
            recruit_at,
            start_at,
            end_at,
            integarl_num,
            content,
            condition: formated,
            sort,
          }
        },
      }

      handlers[this.type]()
    },
    // 填写字段
    addField() {
      this.form.condition.push('')
    },
    removeField(index) {
      this.form.condition.splice(index, 1)
    },
    // 提交
    async submitForm(formName) {
      const { type, form } = this

      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            await addEvent(form)
            this.$message({
              message: type === 'add' ? '已新建活动!' : '已编辑活动!',
              type: 'success',
            })
            this.$emit('onUpdate')
            this.trunOff()
          } catch {
            this.$message.error('出错了!')
          }
        }
      })
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    title() {
      const { type } = this

      const title = {
        add: '新建数据',
        edit: '编辑数据',
      }

      return title[type]
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.handleUpdateFormModelByModalType()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ipt-box {
  // max-width: 512px;
  display: flex;
  align-items: center;
  margin-bottom: 22px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
